/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'gatsby'
import styles from './styles.module.css'
import documentNavigationShape from 'shapes/DocumentNavigation'
import barPlotNavigationShape from 'shapes/BarPlotNavigation'

const DocumentsSidebar = ({
  className,
  documentNavigation,
  barPlotNavigation,
}) => {
  const docs = documentNavigation.map(({ slug, title }) => (
    <li key={slug}>
      <Link to={slug} activeClassName={styles.active}>
        {title}
      </Link>
    </li>
  ))
  const barPlots = barPlotNavigation.map(({ slug, title }) => (
    <li key={slug}>
      <Link to={slug} activeClassName={styles.active}>
        {title}
      </Link>
    </li>
  ))

  return (
    <section className={cx(className, styles.DocumentSidebar)}>
      <header>
        <h3>Documents</h3>
      </header>
      <nav>
        <ul>
          {docs}
          {barPlots}
        </ul>
      </nav>
    </section>
  )
}

DocumentsSidebar.propTypes = {
  className: PropTypes.string,
  documentNavigation: documentNavigationShape.list,
  barPlotNavigation: barPlotNavigationShape.list,
}

export default DocumentsSidebar
